import { render } from "./MobileWallet.vue?vue&type=template&id=303d0170&scoped=true&ts=true"
import script from "./MobileWallet.vue?vue&type=script&lang=ts"
export * from "./MobileWallet.vue?vue&type=script&lang=ts"

import "./MobileWallet.vue?vue&type=style&index=0&id=303d0170&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303d0170"]])

export default __exports__